import { User } from './models/user.model';
import { Component} from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //public static API_ENDPOINT='http://localhost:8000/';
  //public static API_ENDPOINT='http://tour.webbanana.in/';
  //public static API_ENDPOINT='https://khadayatasagpansetu.com/sagpan/';
  // add /wb or /wbb-jss depending on service
    public static API_ENDPOINT='https://khadayatasagpansetu.com/wb-jss/';
  //public static API_ENDPOINT='http://192.168.1.129:3000/';
  //public static API_ENDPOINT='http://niravjadav.com:8080/stocklot/admin/';


  public static user : User = {};
  public static loggedInUser : User = {};

  public static USERS : any[] = [];

  public static DASHBOARD = [ 0 , 0 , 0 , 0];
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts